import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'issueGrpname', 'nmcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/Inventoryoutgroup${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    listheader(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'issueGrpname', 'nmcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/Inventoryoutgroup/list${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("Inventoryoutgroup", obj);
                resolve(data);

            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/Inventoryoutgroup/${obj.issueGrpkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    removeLine(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/Inventoryoutgroup/line/${obj.issueGrpDtlkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },

    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/Inventoryoutgroup/detail/${obj.issueGrpkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    group() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/item/itemcategory`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    headgroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/item/headcategory`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    inventorygroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/inventorycategory/combo`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'issueGrpname', 'nmcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/Inventoryoutgroup/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Invtory_issued_group.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
};